import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import {
  CentralLoginCreateAccountComponent
} from '@app/modules/central-login/action-pages/central-login-create-account.component';
import { CentralLoginRoutingModule } from '@app/modules/central-login/central-login-routing.module';
import { CentralLoginLoginComponent } from '@app/modules/central-login/action-pages/central-login-login.component';
import { SharedModule } from '@app/modules/shared/shared.module';
import { CentralLoginDashboardComponent } from '@app/modules/central-login/pages/central-login-dashboard.component';
import { AuthorizationGuard } from '@app/modules/central-login/guards/authorization-guard';
import {
  CentralLoginForgotPasswordComponent
} from '@app/modules/central-login/action-pages/central-login-forgot-password.component';
import { CentralLoginNewLoginComponent } from '@app/modules/central-login/action-pages/central-login-new-login.component';
import { CentralLoginJoinComponent } from '@app/modules/central-login/action-pages/central-login-join.component';
import { CentralLoginCreateUserComponent } from '@app/modules/central-login/action-pages/central-login-create-user.component';
import { CentralLoginLoginFooterComponent } from '@app/modules/central-login/action-pages/central-login-login-footer.component';
import {
  CentralLoginSelectAccountComponent
} from '@app/modules/central-login/action-pages/central-login-select-account.component';
import { CentralLoginLoginHeaderComponent } from '@app/modules/central-login/action-pages/central-login-login-header.component';
import { CentralLoginLogoutComponent } from '@app/modules/central-login/action-pages/central-login-logout.component';
import { CentralLoginAppHeaderComponent } from '@app/modules/central-login/pages/central-login-app-header.component';
import {
  CentralLoginMailVerifiedComponent
} from '@app/modules/central-login/action-pages/central-login-mail-verified.component';
import { CentralLoginBackgroundSliderComponent } from '@app/modules/central-login/common/central-login-background-slider.component';
import {
  CentralLoginSsoLoginComponent
} from '@app/modules/central-login/action-pages/central-login-sso-login.component';
import { CentralLoginErrorComponent } from '@app/modules/central-login/action-pages/central-login-error.component';
import {
  CentralLoginContactAdminComponent
} from '@app/modules/central-login/action-pages/central-login-contact-admin.component';
import {
  CentralLoginAccountSettingsNavigationComponent
} from '@app/modules/central-login/pages/central-login-account-settings-navigation.component';
import {
  CentralLoginAccountSettingsSecurityComponent
} from '@app/modules/central-login/pages/central-login-account-settings-security.component';
import {
  CentralLoginAccountSettingsPreferencesComponent
} from '@app/modules/central-login/pages/central-login-account-settings-preferences.component';
import {
  CentralLoginAccountSettingsPersonalInfoComponent
} from '@app/modules/central-login/pages/central-login-account-settings-personal-info.component';

@NgModule({
  imports: [FormsModule, CentralLoginRoutingModule, SharedModule],
  declarations: [
    CentralLoginLoginComponent,
    CentralLoginCreateAccountComponent,
    CentralLoginDashboardComponent,
    CentralLoginMailVerifiedComponent,
    CentralLoginForgotPasswordComponent,
    CentralLoginNewLoginComponent,
    CentralLoginJoinComponent,
    CentralLoginCreateUserComponent,
    CentralLoginLoginFooterComponent,
    CentralLoginLoginHeaderComponent,
    CentralLoginSelectAccountComponent,
    CentralLoginLogoutComponent,
    CentralLoginBackgroundSliderComponent,
    CentralLoginSsoLoginComponent,
    CentralLoginErrorComponent,
    CentralLoginContactAdminComponent,
    CentralLoginAccountSettingsNavigationComponent,
    CentralLoginAccountSettingsSecurityComponent,
    CentralLoginAccountSettingsPreferencesComponent,
    CentralLoginAccountSettingsPersonalInfoComponent
  ],
  entryComponents: [],
  providers: [AuthorizationGuard]
})
export class CentralLoginModule {}
